/* __next_internal_client_entry_do_not_use__ NewBaseButton auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { isString } from "__barrel_optimize__?names=isString!=!lodash-es";
import { forwardRef } from "react";
import styles from "./index.module.scss";
import { NewBaseIcon } from "../NewBaseIcon";
import { loading2 } from "@/assets/icons/svgV2";
export const NewBaseButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    innerClassName,
    innerStyle,
    children,
    onClick,
    disabled = false,
    block = false,
    active = false,
    loading = false,
    cancel = false,
    size = "medium",
    preset = "primary",
    ...restProps
  } = props;
  const handleClick = e => {
    if (loading || disabled) {
      e.preventDefault();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const renderLoadingIcon = /*#__PURE__*/_jsx(NewBaseIcon, {
    icon: loading2,
    size: ["nano", "mini", "small"].includes(size) ? 16 : 20,
    className: styles.loading_animation
  });
  const renderChildren = isString(children) ? /*#__PURE__*/_jsx("span", {
    children: children
  }) : children;
  return /*#__PURE__*/_jsxs("button", {
    ref: ref,
    className: classNames({
      [styles.button]: true,
      [styles[preset]]: preset,
      [styles.disabled]: disabled,
      [styles.active]: active,
      [styles.cancel]: cancel,
      [styles.loading]: loading,
      [styles["size_".concat(size)]]: true,
      [styles.block]: block,
      [className]: !!className
    }),
    ...restProps,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.fill
    }), /*#__PURE__*/_jsxs("span", {
      className: classNames([styles.text], [innerClassName]),
      style: innerStyle,
      onClick: handleClick,
      children: [loading && renderLoadingIcon, renderChildren]
    })]
  });
});